'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _leftnav = require('./leftnav.html');

var _leftnav2 = _interopRequireDefault(_leftnav);

var _leftnav3 = require('./leftnav.controller');

var _leftnav4 = _interopRequireDefault(_leftnav3);

require('./leftnav.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var leftNavComponent = {
  restrict: 'E',
  bindings: {},
  template: _leftnav2.default,
  controller: _leftnav4.default,
  controllerAs: 'vm'
};

exports.default = leftNavComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/leftnav/leftnav.component.js
 **/